import { __awaiter } from "tslib";
import { Auth } from 'aws-amplify';
function toGlobalMobile(mobile) {
    if (mobile[0] !== '+') {
        return '+886' + mobile.slice(1);
    }
    else {
        return mobile;
    }
}
export const Options = {
    body: {
        sub: [],
        name: ['#ms.required'],
        username: ['#ms.required']
    },
    init(self, source = {}) {
        let { sub, name, phone_number } = source.attributes || {};
        return {
            sub,
            name,
            username: phone_number
        };
    },
    views: {
        logged(self) {
            return self.$ready;
        }
    },
    loaders: {
        fetch(self, done, fail) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    let user = yield Auth.currentAuthenticatedUser();
                    self.$init(user);
                    done();
                }
                catch (error) {
                    fail(error);
                }
            });
        },
        join(self, done, fail, { name, username, password }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield Auth.signUp({
                        username: toGlobalMobile(username),
                        password,
                        attributes: {
                            name
                        }
                    });
                    done();
                }
                catch (error) {
                    fail(error.message || error);
                }
            });
        },
        signIn(self, done, fail, { username, password }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield Auth.signIn(toGlobalMobile(username), password);
                    done();
                }
                catch (error) {
                    fail(error.code);
                }
            });
        },
        confirmSignUp(self, done, fail, { username, code }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield Auth.confirmSignUp(toGlobalMobile(username), code);
                    done();
                }
                catch (error) {
                    fail(error.message || error);
                }
            });
        },
        sendSms(self, done, fail, { username }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield Auth.resendSignUp(toGlobalMobile(username));
                    done();
                }
                catch (error) {
                    fail(error.message || error);
                }
            });
        },
        signOut(self, done, fail) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield Auth.signOut();
                    window.location.reload();
                    done();
                }
                catch (error) {
                    fail(error.message || error);
                }
            });
        },
        forgotPassword(self, done, fail, { username }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield Auth.forgotPassword(toGlobalMobile(username));
                    done();
                }
                catch (error) {
                    fail(error.message || error);
                }
            });
        },
        forgotPasswordSubmit(self, done, fail, { username, password, code }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield Auth.forgotPasswordSubmit(toGlobalMobile(username), code, password);
                    done();
                }
                catch (error) {
                    fail(error.message || error);
                }
            });
        }
    }
};
